module.exports = __webpack_public_path__ + "img/leaf-bottom.5247e718.png";